import {PersonEntity, PersonType, personTypes,} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {useAuth} from "../providers/AuthProvider/AuthProvider";

export type UsePersonAccessProps = {
  person: PersonEntity
}

export type UsePersonAccessResult = boolean

export const usePersonAccess = (props: UsePersonAccessProps): UsePersonAccessResult => {
  const {person} = props

  const {hasAccess} = useAuth()

  return useMemo(() => {
    const types: PersonType[] = []

    if (hasAccess('person_edit')) {
      for (const type of personTypes) {
        if (hasAccess(`person_${type.code.toLowerCase()}_edit`)) {
          types.push(type)
        }
      }
    }

    return types.findIndex(t => t === person.type) !== -1
  }, [hasAccess, person]);
}
